import React from "react";
import { Grid, Typography,Link } from "@material-ui/core";
import { ClientServicingCss as Styles } from "./css/ClientServicingCss";
import ReactPlayer from "react-player";
import AlertContainer from "../AlertContainer";
import { Alert } from "@material-ui/lab";
import { servicingMessage } from "../../pages/clientServicing/utils";

export default function Hero(props: any) {
    const classes = Styles();
    const { clientDetail } = props;
    let clientFullName: string = '';
    if(clientDetail && clientDetail.payload) {
        clientFullName = clientDetail.payload.firstName + " " + clientDetail.payload.lastName;
    }
    return (
            <div className="serviceAlert">
                <Alert className="mb20" variant="outlined" severity="info">
                    <Typography variant="body1" className={classes.mb0 + " " + classes.floatLeft}>
                        Your servicing portal is currently under construction. If you have any concerns regarding
                        your account or need help navigating the portal, please email us at
                        &nbsp;<Link href="mailto:niw.info@simplicitygroup.com" target={"_blank"}>niw.info@simplicitygroup.com</Link> or call
                        Tech Support at 800-294-9940, ext. 807.
                    </Typography>
                </Alert>
                <div className={classes.containerWidth1700}>
                <div className={classes.agentHero}>
                    <Grid container spacing={2} alignItems="center" >
                        <Grid item xs={12} md={12} lg={6} xl={7}>
                            <Typography variant="h2" align="left" className={classes.colorWhite + " " + classes.title + " mt40md "}>
                                Welcome {clientFullName}
                            </Typography>
                            <Typography variant="subtitle1"
                                        className={classes.colorWhite + " " + classes.mb0 + " " + classes.floatLeft}>
                                Now that you’ve successfully enrolled you will be able to view and manage your
                                policy here. You can view documents, make a yearly contribution payment, file a claim, change
                                your details, and get answers to your policy questions.
                            </Typography>


                        </Grid>
                        <Grid  item xs={12} md={12} lg={6} xl={5} alignContent="center">
                            <ReactPlayer
                                    className="serviceHeroVideo"
                                    controls={true}
                                    playing={false}
                                    loop={true}
                                    autoPlay={true}
                                    volume={0}
                                    muted={true}
                                    url={"https://player.vimeo.com/video/817319011"}
                                    width="100%"
                                    playsinline={true}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
            </div>

    );
}